export default "__VITE_ASSET__DIKOqSX___"